import React from 'react';
import './sec2.css'
import pic12 from '../assets/pic12.png'
import pic13 from '../assets/pic13.png'
import pic14 from '../assets/pic14.png'
import pic15 from '../assets/pic15.png'
import pic16 from '../assets/pic16.png'
import { useState } from 'react';

const Sec2 = () => {

  const [inView, setInView] = useState(false);


  const handleScroll = () => {
    const section = document.querySelector('.sec2');
    if (!section) return;
    const rect = section.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible !== inView) setInView(isVisible);
  };


window.addEventListener('scroll', handleScroll);
window.addEventListener('load', handleScroll);



    return ( 
        <section className='sec2'>
            <section className={`sec2-bg ${inView ? 'animate' : ''}`}>


                <article className='container-sec2 '>
                        <figure className='container-imgs-sec2'>
                            <img className={`img1-sec2 ${inView ? 'animate' : ''}`} src={pic12} alt='picc'></img>
                            <img className='img2-sec2' src={pic13} alt='picc'></img>
                            <img className='img3-sec2' src={pic14} alt='picc'></img>
                            <img className={`img4-sec2 ${inView ? 'animate' : ''}`} src={pic15} alt='picc'></img>
                            <img className='img5-sec2' src={pic16} alt='picc'></img>
                        </figure>

                        <article className='container-text-sec2'>
                            <h1 className='header-sec2'>Character <br />Overview</h1>
                            <article className='container2-text-sec2'>
                                <p className='para-sec2'>Coco Chanel (1883–1971) was a French fashion designer who 
                                    transformed women’s fashion with simple, elegant, and modern
                                     designs. She founded Chanel and remains an icon of timeless
                                      style.</p>
                            </article>
                        </article>
                </article>

           
            </section>

        </section>
     );
}
 
export default Sec2;